"use client";
import AuthorCard from "./AuthorCard";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

const AuthorCarousel = ({ data }) => {
  return (
    <div className="relative mt-5">
      <Carousel
        opts={{
          align: "start",
          loop: true,
          slidesToScroll: "auto",
        }}
        className="w-full"
      >
        <CarouselContent>
          {data?.slice(0, 20)?.map((author, i) => (
            <CarouselItem
              key={i}
              className="basis-1/2 md:basis-1/4 lg:basis-1/6"
            >
              <AuthorCard author={author} />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="absolute top-1/2 transform -translate-y-1/2 left-2 bg-white border border-brand-light text-brand-navy hover:bg-brand-sky hover:text-white hover:border-brand-sky transition-colors shadow-brand-sm" />
        <CarouselNext className="absolute top-1/2 transform -translate-y-1/2 right-2 bg-white border border-brand-light text-brand-navy hover:bg-brand-sky hover:text-white hover:border-brand-sky transition-colors shadow-brand-sm" />
      </Carousel>
    </div>
  );
};

export default AuthorCarousel;